import { render, staticRenderFns } from "./policies.vue?vue&type=template&id=115b2ba9&scoped=true&"
import script from "./policies.vue?vue&type=script&lang=ts&"
export * from "./policies.vue?vue&type=script&lang=ts&"
import style0 from "./policies.vue?vue&type=style&index=0&id=115b2ba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b2ba9",
  null
  
)

export default component.exports